import { render, staticRenderFns } from "./signRecordPage.vue?vue&type=template&id=7b032798&scoped=true&"
import script from "./signRecordPage.vue?vue&type=script&lang=js&"
export * from "./signRecordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b032798",
  null
  
)

export default component.exports